import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <i className="ri-error-warning-line text-6xl text-foreground-200"></i>
        </div>
        <h2 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">
          Strona nie została znaleziona
        </h2>
        <p className="mt-2 text-base text-foreground-500">
          Przepraszamy, ale strona której szukasz nie istnieje.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-4-line"></i>
          </div>
          Wróć do strony głównej
        </Link>
      </div>
    </div>
  );
}